import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  IconButton,
} from "@material-ui/core";
import {
  Info,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Upload/useApi";
import useAuth from "Hooks/Upload/useAuth";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  infoIconCell: {
    textAlign: "center",
    width: "110px",
  },
  infoIcon: {
    textAlign: "center",
    color: "#556cd6",
  },
}));

function Accounts(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [accounts, setAccounts] = React.useState([]);


  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Upload - アカウント一覧";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccounts();
  }, [auth.state.token]);

  const fetchAccounts = () => {
    request({
      method: "GET",
      url: `media/upload/accounts`,
    }).then((result) => {
      setAccounts(result.data.data);
    });
  };

  const onClickInfoButton = (id) => {
    props.history.push(`/upload/top/group/${id}`);
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{dayjs(row.updated_at).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
          <TableCell className={classes.infoIcon}>
          <IconButton 
              color="primary" 
              aria-label="add an Info"
              onClick={() => onClickInfoButton(row.id)}
            >
              <Info />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>アカウント名</TableCell>
                    <TableCell>更新日</TableCell>
                    <TableCell className={classes.infoIconCell}>詳細</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {accounts.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </>
      }
    />
  );
}

export default withRouter(Accounts);
